import BgTeacher from "../assets/teacher.png";

const TeacherPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 font-sans text-gray-800 flex flex-col items-center">
      <img src={BgTeacher} alt="Logo" width="100%" />
    </div>
  );
};

export default TeacherPage;
